import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "size", "placeholderWidth", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import { hasReactChildren } from 'utils/ui';
import Text from 'components/Text';
import TextPlaceholder from 'components/TextPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export var HEADING_SIZES = {
  'extra-small': ['m', 'm'],
  small: ['m', 'l'],
  medium: ['l', 'xl'],
  large: ['xl', 'xxl']
};
var HeadingRender = function HeadingRender(_ref, ref) {
  var as = _ref.as,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    placeholderWidth = _ref.placeholderWidth,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasChildren = hasReactChildren(children);
  return /*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({
    bold: true,
    ref: ref,
    as: as,
    overflow: "wrap",
    size: HEADING_SIZES[size],
    lineHeight: 1.25,
    breakpoints: "m"
  }, otherProps), {}, {
    children: hasChildren ? children : /*#__PURE__*/_jsx(TextPlaceholder, {
      width: placeholderWidth
    })
  }));
};
var Heading = /*#__PURE__*/forwardRef(HeadingRender);
Heading.displayName = 'Heading';
export default Heading;